<div class="gmail-viewer">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Зареждане...</span>
    </div>
  </div>

  <!-- Message Details -->
  <div *ngIf="!loading && messageDetails" class="email-container">

    <!-- Gmail-style Header -->
    <div class="email-header">
      <!-- Subject Line -->
      <div class="subject-line">
        <h2 class="subject-text">{{messageDetails.subject}}</h2>
        <button type="button" class="close-btn" (click)="closeModal()" title="Затвори">
          <i class="fa fa-times"></i>
        </button>
      </div>

      <!-- Classification Badge -->
      <div class="classification-section" *ngIf="selectedClassification !== null">
        <span class="classification-badge" [ngClass]="getClassificationBadgeClass(selectedClassification)">
          <i class="fa fa-tag me-1"></i>{{getClassificationLabel(selectedClassification)}}
        </span>
      </div>

      <!-- Action Toolbar -->
      <div class="action-toolbar">
        <div class="toolbar-left">
          <button class="action-btn" (click)="scrollToReply()" title="Отговори">
            <i class="fa fa-reply"></i>
            <span class="btn-label">Отговори</span>
          </button>
          <button class="action-btn" (click)="toggleDetails()" title="Детайли">
            <i class="fa fa-info-circle"></i>
            <span class="btn-label">Детайли</span>
          </button>
          <button class="action-btn" *ngIf="hasFields()" (click)="toggleDrawer()" title="Raw данни">
            <i class="fa fa-code"></i>
            <span class="btn-label">Raw</span>
          </button>
        </div>
        <div class="toolbar-right">
          <span class="email-date">{{formatDate(messageDetails.dateSent)}}</span>
        </div>
      </div>
    </div>

    <!-- Email Message Card -->
    <div class="email-message-card">

      <!-- Sender Info -->
      <div class="sender-info">
        <div class="sender-avatar">
          <i class="fa fa-user-circle"></i>
        </div>
        <div class="sender-details">
          <div class="sender-name-row">
            <span class="sender-name">{{messageDetails.sender?.name || 'Неизвестен подател'}}</span>
            <button class="details-toggle" (click)="toggleDetails()" [class.active]="showDetails">
              <i class="fa" [class.fa-chevron-down]="!showDetails" [class.fa-chevron-up]="showDetails"></i>
            </button>
          </div>
          <div class="sender-email">
            <span *ngIf="messageDetails.recipientLogin">До: {{messageDetails.recipientLogin.name}}</span>
          </div>
        </div>
      </div>

      <!-- Expandable Details -->
      <div class="message-details" *ngIf="showDetails" [@slideDown]>
        <div class="detail-row">
          <span class="detail-label">От:</span>
          <span class="detail-value">{{messageDetails.sender?.name || 'N/A'}}</span>
        </div>
        <div class="detail-row" *ngIf="messageDetails.recipientLogin">
          <span class="detail-label">До:</span>
          <span class="detail-value">{{messageDetails.recipientLogin.name}}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">Дата:</span>
          <span class="detail-value">{{formatDate(messageDetails.dateSent)}}</span>
        </div>
        <div class="detail-row" *ngIf="messageDetails.dateReceived">
          <span class="detail-label">Получено:</span>
          <span class="detail-value">{{formatDate(messageDetails.dateReceived)}}</span>
        </div>
        <div class="detail-row" *ngIf="messageDetails.messageId">
          <span class="detail-label">ID:</span>
          <span class="detail-value">{{messageDetails.messageId}}</span>
        </div>
        <div class="detail-row" *ngIf="messageDetails.rnu">
          <span class="detail-label">RNU:</span>
          <span class="detail-value">{{messageDetails.rnu}}</span>
        </div>
        <div class="detail-row" *ngIf="messageDetails.templateId">
          <span class="detail-label">Шаблон:</span>
          <span class="detail-value">{{messageDetails.templateId}}</span>
        </div>

        <!-- Classification Selector -->
        <div class="detail-row">
          <span class="detail-label">Класификация:</span>
          <div class="classification-selector">
            <select
              class="form-select form-select-sm"
              [ngModel]="selectedClassification"
              (ngModelChange)="onClassificationChange($event)"
              [disabled]="isReclassifying">
              <option [ngValue]="null">Некласифицирано</option>
              <option [ngValue]="EmailClassificationCategory.Zayavlenie">Заявление</option>
              <option [ngValue]="EmailClassificationCategory.Other">Други</option>
            </select>
            <span *ngIf="isReclassifying" class="ms-2">
              <span class="spinner-border spinner-border-sm"></span>
            </span>
          </div>
        </div>
        <div *ngIf="reclassificationError" class="alert alert-danger alert-sm mt-2">
          <i class="fa fa-exclamation-circle me-1"></i>{{reclassificationError}}
        </div>
      </div>

      <!-- Message Body -->
      <div class="message-body">
        <div class="message-content" [innerText]="getSanitizedMessage()"></div>
      </div>


      <!-- Attachments Section -->
      <div *ngIf="getEnhancedAttachments().length > 0" class="attachments-section">
        <div class="attachments-header">
          <i class="fa fa-paperclip"></i>
          <span>{{getEnhancedAttachments().length}} прикачени файла</span>
        </div>
        <div class="attachments-grid">
          <div class="attachment-card-wrapper" *ngFor="let attach of getEnhancedAttachments()">
            <div class="attachment-card">
              <div class="attachment-icon">
                <i class="fa" [ngClass]="getFileIcon(attach.fileName)"></i>
              </div>
              <div class="attachment-info">
                <div class="attachment-name" [title]="attach.fileName">{{attach.fileName || 'Неизвестен файл'}}</div>
                <div class="attachment-size">{{formatFileSize(attach.size)}}</div>
              </div>
              <button class="attachment-download" (click)="openFile(attach.downloadLink)" title="Изтегли">
                <i class="fa fa-download"></i>
              </button>
            </div>

            <!-- Expandable attachment details -->
            <div class="attachment-details" *ngIf="attach.blobId || attach.hash || (attach.signatures && attach.signatures.length > 0)">
              <button class="details-btn" (click)="toggleAttachmentDetails(attach)">
                <i class="fa" [ngClass]="attach.showDetails ? 'fa-chevron-up' : 'fa-chevron-down'"></i> Детайли
              </button>

              <div class="details-content" *ngIf="attach.showDetails" [@slideDown]>
                <div class="detail-item" *ngIf="attach.blobId">
                  <span class="label">Blob ID:</span>
                  <span class="value">{{attach.blobId}}</span>
                </div>
                <div class="detail-item" *ngIf="attach.documentRegistrationNumber">
                  <span class="label">Рег. номер:</span>
                  <span class="value">{{attach.documentRegistrationNumber}}</span>
                </div>
                <div class="detail-item" *ngIf="attach.isMalicious !== null && attach.isMalicious !== undefined">
                  <span class="label">Статус:</span>
                  <span class="badge" [ngClass]="attach.isMalicious ? 'bg-danger' : 'bg-success'">
                    {{attach.isMalicious ? 'Зловреден' : 'Безопасен'}}
                  </span>
                </div>

                <!-- Signatures -->
                <div *ngIf="attach.signatures && attach.signatures.length > 0" class="signatures-section">
                  <div class="signatures-header">
                    <i class="fa fa-certificate"></i> Подписи ({{attach.signatures.length}})
                  </div>
                  <div *ngFor="let signature of attach.signatures" class="signature-item">
                    <div class="sig-detail">
                      <span class="label">Издател:</span>
                      <span class="value">{{signature.issuer}}</span>
                    </div>
                    <div class="sig-detail">
                      <span class="label">Субект:</span>
                      <span class="value">{{signature.subject}}</span>
                    </div>
                    <div class="sig-detail">
                      <span class="label">Валиден:</span>
                      <span class="value">{{formatDateTime(signature.validFrom)}} - {{formatDateTime(signature.validTo)}}</span>
                    </div>
                    <span class="badge" [ngClass]="signature.validAtTimeOfSigning ? 'bg-success' : 'bg-warning'">
                      {{signature.validAtTimeOfSigning ? 'Валиден' : 'Невалиден'}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional Fields -->
      <div *ngIf="messageDetails.fields && hasFields() && getParsedFields().length > 0" class="additional-fields">
        <div class="fields-header">
          <i class="fa fa-info-circle"></i>
          <span>Допълнителна информация</span>
        </div>
        <div class="fields-grid">
          <div class="field-item" *ngFor="let field of getParsedFields()">
            <div class="field-label">{{field.key}}</div>
            <div class="field-value">{{formatFieldValue(field.value)}}</div>
          </div>
        </div>
      </div>

    </div>

    <!-- Gmail-style Reply Section -->
    <div class="reply-section" #replySection>
      <div class="reply-trigger" *ngIf="!showReplyForm" (click)="showReplyForm = true; focusReplyBox()">
        <div class="reply-avatar">
          <i class="fa fa-user-circle"></i>
        </div>
        <div class="reply-placeholder">Кликнете тук за отговор...</div>
      </div>

      <!-- Reply Form (Gmail-style inline) -->
      <div class="reply-form-container" *ngIf="showReplyForm" [@slideDown]>
        <div class="reply-form">

          <div *ngIf="replyError" class="alert alert-danger">
            <i class="fa fa-exclamation-triangle me-2"></i>{{ replyError }}
            <button type="button" class="btn-close" (click)="replyError = null"></button>
          </div>

          <div class="form-group">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="replySubject"
              [disabled]="isSendingReply"
              placeholder="Тема">
          </div>

          <div class="form-group">
            <textarea
              #replyTextarea
              class="form-control reply-textarea"
              [(ngModel)]="replyBody"
              [disabled]="isSendingReply"
              placeholder="Напишете вашия отговор..."
              rows="8"></textarea>
          </div>

          <div class="reply-actions">
            <button
              type="button"
              class="btn btn-primary btn-send"
              (click)="sendReply()"
              [disabled]="isSendingReply || !replySubject || !replyBody">
              <span *ngIf="isSendingReply" class="spinner-border spinner-border-sm me-2"></span>
              <i *ngIf="!isSendingReply" class="fa fa-paper-plane me-2"></i>
              {{ isSendingReply ? 'Изпращане...' : 'Изпрати' }}
            </button>
            <button
              type="button"
              class="btn btn-link btn-cancel"
              (click)="cancelReply()"
              [disabled]="isSendingReply">
              Откажи
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Raw Data Drawer (Gmail-style side panel) -->
  <div class="raw-data-drawer" [class.open]="drawerOpen">
    <div class="drawer-header">
      <h5 class="drawer-title">
        <i class="fa fa-code me-2"></i>Raw JSON данни
      </h5>
      <button type="button" class="drawer-close" (click)="toggleDrawer()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="drawer-body">
      <div class="drawer-info">
        <i class="fa fa-info-circle me-2"></i>
        Необработени JSON данни от допълнителната информация
      </div>
      <pre class="raw-json-content">{{getRawFieldsJson()}}</pre>
    </div>
  </div>

  <!-- Backdrop for drawer -->
  <div class="drawer-backdrop" [class.show]="drawerOpen" (click)="toggleDrawer()" *ngIf="drawerOpen"></div>
</div>
